const SHARED_DEPENDENCIES_GLOBAL_NAME = '__SHARED_DEPENDENCIES__';

export { SHARED_DEPENDENCIES_GLOBAL_NAME };
